import useGetApi from 'src/api/useGetApi';

export interface CoreEnumDTO {
  id: string;
  name: string;
  description: string;
}

export interface CoreCustomFieldDTO {
  id: string;
  model: string;
  fieldName: string;
  fieldType: string;
  description: string;
  isMultiple: boolean;
  coreEnumId: string | null;
  coreEnum?: CoreEnumDTO | null;
}

interface PageInfo {
  hasNextPage: boolean;
  endCursor: string | null;
}

interface QueryParams {
  first?: number;
  after?: string;
  model?: string;
  fieldName?: string;
  fieldType?: string;
  includeEnum?: boolean;
}

type ApiResponse = {
  edges: CoreCustomFieldDTO[];
  pageInfo: PageInfo;
  totalCount: number;
};

const useCoreCustomFields = (params?: QueryParams, enabled?: boolean) => {
  return useGetApi<ApiResponse>({
    endpoint: 'core/core-custom-fields',
    queryParameters: params,
    options: {
      enabled,
    },
  });
};

export default useCoreCustomFields;
